import { productIdFormat } from "@redotech/redo-product-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const ProductTransformMappingSchema_ = z.object({
  sourceProductId: productIdFormat.schema,
  sourceTitle: z.string(),
  sourceSku: z.string().nullable(),
  targetProductId: productIdFormat.schema,
  targetTitle: z.string(),
  targetSku: z.string().nullable(),
});

export const ProductTransformMappingSchema: z.ZodType<ProductTransformMapping> =
  ProductTransformMappingSchema_;
export interface ProductTransformMapping extends z.infer<
  typeof ProductTransformMappingSchema_
> {}

export const getProductTransformMappings = unaryRpc({
  name: "getProductTransformMappings" as const,
  input: z.object({}),
  output: z.object({ mappings: z.array(ProductTransformMappingSchema) }),
});

export const createProductTransformMapping = unaryRpc({
  name: "createProductTransformMapping" as const,
  input: z.object({
    sourceProductId: productIdFormat.schema,
    targetProductId: productIdFormat.schema,
  }),
  output: z.object({ mapping: ProductTransformMappingSchema }),
});

export const deleteProductTransformMapping = unaryRpc({
  name: "deleteProductTransformMapping" as const,
  input: z.object({ sourceProductId: productIdFormat.schema }),
  output: z.object({ ok: z.literal(true) }),
});
